<template>
  <div id="app">
    <router-view></router-view>
    
    <!-- Promotion Popup-->
    <!-- Prenatal Class Popup -->
    <div class="prenatal-popup" v-if="showPrenatalPopup">
      <div class="prenatal-popup-content">
        <button class="close-button" @click="closePrenatalPopup">×</button>
        <div class="popup-image">
          <img src="@/assets/events/prenatal.png" alt="Prenatal Classes" class="main-image" />
        </div>
        <div class="popup-text">
          <img src="@/assets/events/discount_2025.png" alt="Prenatal Classes" class="main-image" />
        </div>
        <!--<div class="popup-text">
          <h3>{{$t("popup.popup-title")}}</h3>
          <p>{{$t("popup.popup-text")}}</p>
          <p>{{$t("popup.popup-hour")}}</p>
          <div class="instructors">
            <div class="instructor-profile">
              <img src="@/assets/events/cristy_milling.jpeg" alt="Cristy Milling, RN, IBCLC" class="instructor-image" />
              <div class="instructor">Cristy Milling, RN, IBCLC</div>
            </div>
          </div>
          <div class="button-group">
            <button class="learn-more-button" @click="learnMoreAboutPrenatal">{{$t("popup.learn-more")}}</button>
            <button class="no-thanks-button" @click="closePrenatalPopup">{{$t("popup.no-thanks")}}</button>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { initializeBootstrapComponents } from '@/utils/bootstrap-helpers';

export default {
  data() {
    return {
      showPrenatalPopup: false //false
    };
  },
  created() {
    // Check if we're in a browser environment (not prerendering)
    if (typeof window !== 'undefined') {
      // Load popup state from session storage
      const hasVisitedInSession = sessionStorage.getItem('hasVisitedSite');
      
      if (!hasVisitedInSession) {
        // Wait until hydration is complete
        this.$nextTick(() => {
          setTimeout(() => {
            this.showPrenatalPopup = true; //false
          }, 3000);
        });

        sessionStorage.setItem('hasVisitedSite', 'true');
      }
    }
  },
  mounted() {
    // For when the component is mounted during client-side rendering
    // This ensures popups work after prerendering
    if (typeof window !== 'undefined') {
      const hasVisitedInSession = sessionStorage.getItem('hasVisitedSite');
      
      if (!hasVisitedInSession) {
        setTimeout(() => {
          this.showPrenatalPopup = true; //false
        }, 3000);

        sessionStorage.setItem('hasVisitedSite', 'true'); //true
      }
      
      // Force re-render the component to ensure client-side hydration
      this.$forceUpdate();
    }

    // Initialize Bootstrap components when app is mounted
    this.$nextTick(() => {
      initializeBootstrapComponents();
    });
  },
  watch: {
    // Re-initialize Bootstrap components on route change
    $route() {
      this.$nextTick(() => {
        initializeBootstrapComponents();
      });
    }
  },
  methods: {
    closePrenatalPopup() {
      this.showPrenatalPopup = false;
    },
    learnMoreAboutPrenatal() {
      // Use the router instance directly instead of relying on the prerendered version
      this.$router.push('/prenatal-classes');
      this.closePrenatalPopup();
    }
  }
};
</script>

<style scoped>
.prenatal-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-in-out;
}

.prenatal-popup-content {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  width: 90%;
  max-width: 900px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  position: relative;
  animation: slideUp 0.4s ease-out;
}

.popup-image {
  width: 45%; 
  height: auto;
}

.main-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.popup-text {
  padding: 2rem;
  width: 55%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.instructors {
  display: flex;
  gap: 2rem;
  margin: 1.5rem 0;
  justify-content: center;
}

.instructor-profile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.instructor-image {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #f8f0f1;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.popup-text h3 {
  color: #cc0d1f;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.popup-text p {
  color: #334155;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  color: #334155;
  cursor: pointer;
  z-index: 10;
}

.button-group {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  justify-content: flex-start;
}

.learn-more-button {
  background-color: #cc0d1f;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
}

.no-thanks-button {
  background-color: transparent;
  color: #334155;
  border: 1px solid #334155;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s, transform 0.1s;
}

.no-thanks-button:hover {
  background-color: #f1f5f9;
}

.learn-more-button:hover {
  background-color: #ff4d4d;
}

.learn-more-button:active, .no-thanks-button:active {
  transform: scale(0.98);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { transform: translateY(50px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* For mobile responsiveness */
@media (max-width: 768px) {
  .prenatal-popup-content {
    flex-direction: column;
  }
  
  .popup-image, .popup-text {
    width: 100%;
  }
  
  .popup-image {
    height: 250px;
  }
}
</style>
